// simplebox/insertsimpleboxcommand.js

import Command from '@ckeditor/ckeditor5-core/src/command';
import { LivePosition } from 'ckeditor5/src/engine';

export default class AddQuestionCommand extends Command {

  constructor(editor, command) {
    super(editor);
    this._command = command
    this._positionToInsert = true;
  }

  execute(allResult, metricId, ignoreList) {
    const editor = this.editor;
    const model = editor.model;
    if (this._command === "getAISuggestions") {
      const modelDocument = editor.model.document;
      const wordCountPlugin = editor.plugins.get('WordCount');
      let wordCount = wordCountPlugin.words;
      const documentRange = model.createRangeIn(model.document.getRoot());
      let grammarCount = 0;
      let readabilityCount = 0;
      let markerObj = {};

      model.change(writer => {
        for (const searchMarker of model.markers.getMarkersGroup('grammar')) {
          writer.removeMarker(searchMarker);
        }
        for (const searchMarker of model.markers.getMarkersGroup('passive')) {
          writer.removeMarker(searchMarker);
        }
        for (const searchMarker of model.markers.getMarkersGroup('preadability')) {
          writer.removeMarker(searchMarker);
        }
        for (const searchMarker of model.markers.getMarkersGroup('sentiment')) {
          writer.removeMarker(searchMarker);
        }
        for (const searchMarker of model.markers.getMarkersGroup('emotion')) {
          writer.removeMarker(searchMarker);
        }
        let index = 0;
        for (const value of documentRange.getWalker()) {
          let item = value.item;
          const textNode = item.textNode;
          if (textNode && item.is('$textProxy') && item.data && allResult && allResult[index] && allResult[index].value && allResult[index].value.text && item.data === allResult[index].value.text) {
            const { parent, startOffset } = textNode;
            if (allResult[index].value.response && allResult[index].value.response.length !== 0) {
              allResult[index].value.response.map(el => {
                if (!ignoreList.includes(el.subcategory)) {
                  if (el.report === 'grammar' || el.report === 'passive') {
                    grammarCount++;
                  } else if (el.report === 'preadability' && el.category !== 'preadability3') {
                    readabilityCount++;
                  }
                }
                if (this.checkAISuggestionType(el, metricId) && !ignoreList.includes(el.subcategory)) {
                  const label = el.report + ':' + "your" + ':' + el.id;
                  const start = writer.createPositionAt(parent, startOffset + el.start_pos);
                  const end = writer.createPositionAt(parent, startOffset + el.end_pos + 1);
                  const range = writer.createRange(start, end);

                  const nodeStart = writer.createPositionAt(parent, startOffset + 0);
                  const nodeEnd = writer.createPositionAt(parent, startOffset + value.length);

                  const leftLivePosition = LivePosition.fromPosition(nodeStart);
                  leftLivePosition.stickiness = 'toPrevious';

                  const rightLivePosition = LivePosition.fromPosition(nodeEnd);
                  rightLivePosition.stickiness = 'toNext';

                  modelDocument.once('change:data', () => {
                    this._positionToInsert = this.checkForValidPosition(leftLivePosition, rightLivePosition);
                    leftLivePosition.detach();
                    rightLivePosition.detach();
                  }, { priority: 'high' });

                  if (this._positionToInsert) {
                    const marker = writer.addMarker(label, { range, usingOperation: false });
                    markerObj[el.id] = marker;
                  }
                }
              });
            }
            index++;
          }
        }
      });
      return {
        grammarCount: grammarCount,
        grammarPercentage: 100 - (Math.ceil((grammarCount / wordCount) * 100)),
        wordCount: wordCount,
        readabilityCount: readabilityCount,
        readabilityPercentage: 100 - (Math.ceil((readabilityCount / wordCount) * 100)),
        markerObj: markerObj
      }
    } else if (this._command === "removeSuggestionMarkers") {
      model.change(writer => {
        for (const searchMarker of model.markers.getMarkersGroup('grammar')) {
          writer.removeMarker(searchMarker);
        }
        for (const searchMarker of model.markers.getMarkersGroup('passive')) {
          writer.removeMarker(searchMarker);
        }
        for (const searchMarker of model.markers.getMarkersGroup('preadability')) {
          writer.removeMarker(searchMarker);
        }
        for (const searchMarker of model.markers.getMarkersGroup('sentiment')) {
          writer.removeMarker(searchMarker);
        }
        for (const searchMarker of model.markers.getMarkersGroup('emotion')) {
          writer.removeMarker(searchMarker);
        }
      });
    }
  }

  checkAISuggestionType(element, metricId) {
    const report = element && element.report;
    const category = element && element.category;
    switch (metricId) {
      case "grammar":
        return report === "grammar" || report === "passive";
      case "preadability":
        return report === "preadability" && category !== 'preadability3';
      case "sentiment":
        return report === "sentiment";
      case "emotion":
        return report === "emotion";
      default:
        return false;
    }
  }

  checkForValidPosition(leftPosition, rightPosition) {
    let positionToInsertLeft = LivePosition.fromPosition(leftPosition);
    let positionToInsertRight = LivePosition.fromPosition(rightPosition);
    if (positionToInsertLeft.root.rootName === '$graveyard' || positionToInsertRight.root.rootName === '$graveyard') {
      console.log("graveyard==>", positionToInsertLeft, positionToInsertRight);
      return false;
    }
    return true;
  }

}
